"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "m11.446 12 2.477-2.477a1.12 1.12 0 0 0 .335-.83 1.2 1.2 0 0 0-.335-.853 1.148 1.148 0 0 0-.858-.359 1.181 1.181 0 0 0-.859.359L8.91 11.142c-.24.245-.362.53-.362.857 0 .327.121.613.362.859l3.323 3.322c.237.238.519.354.845.35.326-.006.608-.129.845-.37.223-.237.338-.519.342-.845a1.13 1.13 0 0 0-.349-.845L11.446 12ZM1 12c0-1.526.289-2.957.866-4.295a11.1 11.1 0 0 1 2.35-3.49 11.1 11.1 0 0 1 3.49-2.35A10.723 10.723 0 0 1 12 1c1.526 0 2.957.289 4.295.866a11.1 11.1 0 0 1 3.49 2.35 11.1 11.1 0 0 1 2.35 3.49C22.71 9.042 23 10.473 23 12c0 1.526-.288 2.957-.866 4.295a11.099 11.099 0 0 1-2.35 3.49 11.095 11.095 0 0 1-3.49 2.35A10.723 10.723 0 0 1 12 23c-1.526 0-2.957-.288-4.295-.866a11.1 11.1 0 0 1-3.49-2.35 11.1 11.1 0 0 1-2.35-3.49A10.723 10.723 0 0 1 1 12Zm2.453 0c0 2.39.827 4.413 2.48 6.067 1.654 1.653 3.676 2.48 6.067 2.48 2.39 0 4.413-.827 6.067-2.48 1.653-1.654 2.48-3.677 2.48-6.067s-.827-4.413-2.48-6.067C16.413 4.28 14.39 3.453 12 3.453s-4.413.827-6.067 2.48C4.28 7.587 3.453 9.61 3.453 12Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};